import React from 'react'
import PropTypes from 'prop-types'
import {renderPagesSwitch} from './utils/contentRenderer'
import {extractSeoFromCmsPage, transformOpenGraphTags} from './utils/utils'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getSiteEnvVarValue} from '../../utils/site-config'
import Seo from '../seo'

// Error page - lazy loaded to prevent SSR issues
const PageNotFound = React.lazy(() => import('../../pages/page-not-found'))

const Optimizely = ({content, area, isLoading, disableSeo = false}) => {
    const {app: appConfig} = getConfig()
    const {site} = useMultiSite()
    const siteId = site?.id
    const pwaDomainSite = getSiteEnvVarValue(appConfig, 'PWA_DOMAIN_SITE', siteId) || ''

    if (content?.item) {
        const pageData = content.item

        const seoData = !disableSeo ? extractSeoFromCmsPage(pageData, pwaDomainSite) : null
        const openGraphTags = seoData ? transformOpenGraphTags(seoData.openGraphTags) : []

        return (
            <>
                {seoData && (seoData.metaTitle || seoData.metaDescription || seoData.canonicalUrl || seoData.noIndex || openGraphTags.length > 0) && (
                    <Seo
                        title={seoData.metaTitle}
                        description={seoData.metaDescription}
                        canonicalUrl={seoData.canonicalUrl}
                        noIndex={seoData.noIndex}
                        openGraphTags={openGraphTags}
                    >
                        {seoData.canonicalUrl && <link rel="canonical" href={seoData.canonicalUrl} />}
                    </Seo>
                )}
                {renderPagesSwitch(pageData, area || '')}
            </>
        )
    }

    // During loading with no content yet, return null
    // The parent component should handle showing a loader if needed
    if (isLoading) {
        return null
    }

    // Content genuinely not found (empty items array after loading) → show 404
    // Using React.Suspense to handle lazy loading of PageNotFound
    return (
        <React.Suspense fallback={null}>
            <PageNotFound />
        </React.Suspense>
    )
}

Optimizely.displayName = 'Optimizely'

Optimizely.propTypes = {
    content: PropTypes.object,
    area: PropTypes.string,
    isLoading: PropTypes.bool,
    disableSeo: PropTypes.bool
}

export default Optimizely
